import { render, staticRenderFns } from "./prediction.vue?vue&type=template&id=235c7642&"
import script from "./prediction.vue?vue&type=script&lang=js&"
export * from "./prediction.vue?vue&type=script&lang=js&"
import style0 from "./prediction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235c7642')) {
      api.createRecord('235c7642', component.options)
    } else {
      api.reload('235c7642', component.options)
    }
    module.hot.accept("./prediction.vue?vue&type=template&id=235c7642&", function () {
      api.rerender('235c7642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/prediction.vue"
export default component.exports